import { render, staticRenderFns } from "./BoletinPeriodo.vue?vue&type=template&id=8bbcd1e6&scoped=true&"
import script from "./BoletinPeriodo.vue?vue&type=script&lang=js&"
export * from "./BoletinPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbcd1e6",
  null
  
)

export default component.exports